import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	reportToAtlassianDefault: {
		id: 'atlassian-intelligence.prompt-response.report-to-atlassian-button.report-to-atlassian-default',
		defaultMessage: 'Report to Atlassian',
		description: 'Default aria-label for Report to Atlassian feedback button',
	},
});
